// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.top-ico[data-v-079a88d9] {\r\n\tfont-size: 18px;\r\n\theight: 35px;\r\n\tborder-radius: 5px;\r\n\tmargin-left: 10px;\r\n\tpadding: 0 17px;\r\n\tborder: 1px solid var(--main-blue-4);\r\n\tbackground: var(--main-blue-2);\n}\n.top-ico[data-v-079a88d9]:hover:not(.disabled) {\r\n\tbackground: var(--main-blue-1);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
